import React from 'react';

const ErrorMessage = ({ 
  title = "Something went wrong", 
  message = "An error occurred while loading data. Please try again.", 
  onRetry, 
  isRetrying = false,
  showRetryButton = true,
  className = ""
}) => {
  return (
    <div className={`error-message-container ${className}`} style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      border: '1px solid #e9ecef',
      borderRadius: '8px',
      margin: '20px 0',
      minHeight: '200px'
    }}>
      {/* Error Icon */}
      <div style={{
        fontSize: '48px',
        color: '#dc3545',
        marginBottom: '16px',
        opacity: 0.8
      }}>
        ⚠️
      </div>
      
      {/* Error Title */}
      <h3 style={{
        color: '#dc3545',
        fontSize: '20px',
        fontWeight: '600',
        margin: '0 0 8px 0',
        lineHeight: '1.2'
      }}>
        {title}
      </h3>
      
      {/* Error Message */}
      <p style={{
        color: '#6c757d',
        fontSize: '14px',
        margin: '0 0 24px 0',
        lineHeight: '1.5',
        maxWidth: '400px'
      }}>
        {message}
      </p>
      
      {/* Retry Button */}
      {showRetryButton && onRetry && (
        <button
          onClick={onRetry}
          disabled={isRetrying}
          style={{
            backgroundColor: isRetrying ? '#6c757d' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: isRetrying ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            opacity: isRetrying ? 0.7 : 1
          }}
          onMouseOver={(e) => {
            if (!isRetrying) {
              e.target.style.backgroundColor = '#0056b3';
              e.target.style.transform = 'translateY(-1px)';
            }
          }}
          onMouseOut={(e) => {
            if (!isRetrying) {
              e.target.style.backgroundColor = '#007bff';
              e.target.style.transform = 'translateY(0)';
            }
          }}
        >
          {isRetrying ? (
            <>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #ffffff',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }} />
              Retrying...
            </>
          ) : (
            <>
              <span>🔄</span>
              Try Again
            </>
          )}
        </button>
      )}
      
      {/* Additional Help Text */}
      <p style={{
        color: '#adb5bd',
        fontSize: '12px',
        margin: '16px 0 0 0',
        lineHeight: '1.4'
      }}>
        If the problem persists, please contact support or refresh the page.
      </p>
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ErrorMessage;
